import './Header.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { useLogout } from '../../hooks/useLogout';
import { isAdminRole } from '../../utils/roles';
import YandexLoginButton from '../YandexLoginButton/YandexLoginButton';

type HeaderProps = {
  variant?: 'public' | 'app';
  /** Не показывать кнопки «Войти» и «Войти через Яндекс» (страницы авторизации). */
  hideAuthActions?: boolean;
};

type NavItem = {
  label: string;
  onClick: () => void;
  isActive: boolean;
};

function Header({ variant = 'app', hideAuthActions = false }: HeaderProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const logout = useLogout();
  const { isLoggedIn } = useSelector((state: RootState) => state.loggedIn);
  const { user } = useCurrentUser({
    enabled: isLoggedIn,
    onUnauthorized: logout,
  });

  const goToProtected = (path: string) => {
    navigate(isLoggedIn ? path : '/');
  };

  const navItems: NavItem[] = isLoggedIn
    ? [
        { label: 'NEURO BOOST', onClick: () => navigate('/'), isActive: location.pathname === '/' },
        {
          label: 'ВОПРОСЫ',
          onClick: () => goToProtected('/app'),
          isActive: location.pathname === '/app' || location.pathname.startsWith('/app/questions'),
        },
        {
          label: 'СОБЕСЕДЫ',
          onClick: () => goToProtected('/app/interviews'),
          isActive: location.pathname.startsWith('/app/interviews'),
        },
      ]
    : [
        { label: 'NEURO BOOST', onClick: () => navigate('/'), isActive: location.pathname === '/' },
        { label: 'О ПРОДУКТЕ', onClick: () => navigate('/about'), isActive: location.pathname === '/about' },
      ];

  return (
    <header className={`header header_variant_${variant}`}>
      <div className="header__container">
        <button className="header__brand" type="button" onClick={() => navigate('/')} aria-label="CODE CAREER">
          <span className="header__heroWord header__heroWord_code">CODE</span>
          <span className="header__heroWord header__heroWord_career">CAREER</span>
        </button>

        <nav className="header__nav" aria-label="Основная навигация">
          <div className="header__navInner">
            {navItems.map((item) => (
              <button
                key={item.label}
                className={`header__navButton ${item.isActive ? 'header__navButton_active' : ''}`}
                type="button"
                onClick={item.onClick}
              >
                {item.label}
              </button>
            ))}

            {isAdminRole(user?.role) ? (
              <button
                className={`header__navButton ${location.pathname.startsWith('/app/admin') && !location.pathname.startsWith('/app/admin/content') ? 'header__navButton_active' : ''}`}
                type="button"
                onClick={() => navigate('/app/admin')}
              >
                ADMIN
              </button>
            ) : null}
          </div>
        </nav>

        <div className="header__actions">
          {isLoggedIn ? (
            <>
              {user?.photoUrl ? (
                <img className="header__avatar" src={user.photoUrl} alt={user.username} referrerPolicy="no-referrer" />
              ) : null}
              <button className="header__text" type="button" onClick={() => goToProtected('/app/profile')}>
                Профиль
              </button>
            </>
          ) : hideAuthActions ? null : (
            <>
              <button className="header__text" type="button" onClick={() => navigate('/login')}>
                Войти
              </button>
              <YandexLoginButton className="header__text" />
            </>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
